import React from "react";
import { dialog, Button, Progress, InfiniteScroll } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  FloatingForm,
  SubmitFormBaseList,
} from "../../../components/common/Converter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import CardView from "../../../components/common/CardView";
import withRouter from "../../../withRouter";
import Table from "../../../components/Table";
import FormFactory from "../../../components/FormFactory";
import Search from "../../../components/Search";
import PortalSettingsPresenter from "./PortalSettingsPresenter";

class PortalSettingsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PortalSettingsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      object: {},
      isEdited: false,
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "portal_settings";
  }

  onChange() {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
      },
    }));
  }

  async hanldeSubmit() {
    await upsertUseCase().execute(this.getCollectionName(), this.state.object);
    this.setState({ isEdited: false });
    this.refetchData();
  }

  // delete function
  async handleViewData(data) {
    // await this.presenter.deleteObjectUseCase.execute("portal_settings", id);
    // this.refetchData();
    const viewObj = await findObjectUseCase().execute(
      this.getCollectionName(),
      {
        where: { id: data.id },
      }
    );
    this.setState({ object: viewObj[0], isEdited: true, isView: true });
  }

  // edit function
  async handleEditData(object) {
    this.setState({ object, isEdited: true, isView: false });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddRole() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Organizational Strucure {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={this.handleAddRole.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleViewData.bind(this)}
                objectData={this.handleEditData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "delete",
                  },
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "acl"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
          {this.state.isEdited && (
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">Parameter Details</h4>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.hanldeSubmit();
                  }}
                >
                  {/* <hr /> */}
                  <div className="p-2">
                    <FormFactory
                      className="ps-3 pe-3 pt-2 pb-3"
                      schema={schema}
                      object={this.state.object}
                      disabled={this.state.isView}
                      onChange={this.onChange.bind(this)}
                    />
                  </div>

                  <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                    <button
                      className="btn btn-light"
                      type="button"
                      onClick={() => this.setState({ isEdited: false })}
                    >
                      Cancel
                    </button>
                    {!this.state.isView && (
                      <button
                        className="btn btn-primary"
                        // onClick={this.hanldeSubmit.bind(this)}
                        type="submit"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </form>
              </CardView>
            </FloatingForm>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(PortalSettingsPage);
